var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWpf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 288.1 250",
    style: {
      enableBackground: "new 0 0 288.1 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st5{fill:#1969bc}.st13{fill:#0d82ca}.st23{fill:#1e5cb3}.st32{fill:#054a89}")), /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M228.2 28.4c0-.5-.1-.8-.4-1.1-.3-.2-.8-.4-1.6-.4h-1.1v2.9h1.3c1.3 0 1.8-.5 1.8-1.4zm1.7 6h-1.4l-.9-2c-.5-1-1-1.5-1.5-1.5h-.8v3.6H224V26h2.4c1.1 0 1.9.2 2.4.7.5.4.7.9.7 1.6 0 .6-.2 1.1-.6 1.5-.4.4-.9.7-1.6.8.5.1.9.6 1.4 1.6l1.2 2.2zm2.6-4.2c0-1.7-.6-3.1-1.7-4.2s-2.5-1.7-4.2-1.7c-1.7 0-3.1.6-4.2 1.7s-1.7 2.5-1.7 4.2c0 1.7.6 3.1 1.7 4.2s2.5 1.7 4.2 1.7c1.6 0 3-.6 4.2-1.7 1.2-1.1 1.7-2.5 1.7-4.2zm.8 0c0 1.9-.6 3.4-1.9 4.7-1.3 1.3-2.9 1.9-4.8 1.9s-3.5-.6-4.8-1.9c-1.3-1.2-1.9-2.8-1.9-4.7 0-1.9.6-3.4 1.9-4.7 1.3-1.3 2.9-1.9 4.8-1.9s3.4.6 4.7 1.8c1.4 1.3 2 2.9 2 4.8zM52.1 53.8H48V30.3c0-1.9.1-4.1.3-6.8h-.1c-.4 1.6-.7 2.7-1 3.4L35.3 53.8h-2l-12-26.7c-.3-.7-.7-1.9-1-3.6h-.1c.1 1.4.2 3.7.2 6.8v23.5h-4v-35h5.4l10.7 24.4c.8 1.8 1.3 3.2 1.6 4.2h.2c.7-1.9 1.3-3.3 1.7-4.3l11-24.3h5.1v35zM64.8 53.8h-4v-25h4v25zm.6-33.9c0 .7-.3 1.4-.8 1.9s-1.1.8-1.9.8c-.7 0-1.3-.2-1.8-.7-.5-.5-.8-1.1-.8-1.9 0-.7.3-1.3.8-1.8s1.1-.7 1.8-.7 1.4.2 1.9.7c.6.3.8.9.8 1.7zM89.7 52.7c-1.9 1.2-4.2 1.8-6.9 1.8-3.6 0-6.5-1.2-8.7-3.6-2.1-2.3-3.1-5.3-3.1-9 0-4.1 1.2-7.4 3.5-9.9s5.5-3.8 9.5-3.8c2.2 0 4.1.4 5.8 1.3v4.1c-1.9-1.3-3.8-2-6-2-2.5 0-4.6.9-6.2 2.7-1.7 1.8-2.5 4.2-2.5 7.3 0 2.9.8 5.2 2.3 6.9 1.5 1.7 3.6 2.5 6.2 2.5 2.2 0 4.2-.7 6.2-2.1v3.8h-.1zM108.8 32.9c-.7-.5-1.7-.8-3.1-.8-1.6 0-3 .7-4.1 2.2-1.3 1.6-1.9 3.9-1.9 6.8v12.8h-4v-25h4V34h.1c.6-1.8 1.5-3.2 2.7-4.2 1.1-.9 2.4-1.4 3.8-1.4 1.1 0 1.9.1 2.4.3l.1 4.2zM131.1 41.4c0-3.2-.7-5.6-2.2-7.3-1.4-1.6-3.4-2.4-5.9-2.4-2.5 0-4.5.8-6 2.4-1.6 1.7-2.4 4.2-2.4 7.4 0 3 .8 5.3 2.3 7 1.5 1.7 3.5 2.5 6.1 2.5 2.6 0 4.6-.9 6-2.6 1.4-1.6 2.1-4 2.1-7m4.1-.2c0 4-1.1 7.2-3.4 9.6-2.3 2.4-5.3 3.6-9.1 3.6s-6.7-1.2-8.9-3.6c-2.1-2.3-3.2-5.4-3.2-9.2 0-4.4 1.2-7.7 3.7-10.1 2.3-2.2 5.3-3.3 9.1-3.3 3.7 0 6.6 1.2 8.7 3.5 2.1 2.3 3.1 5.5 3.1 9.5M155.1 47.1c0 2-.8 3.7-2.3 5.1-1.7 1.5-4 2.2-6.9 2.2-2.4 0-4.4-.5-6.2-1.5v-4.3c2 1.6 4.1 2.4 6.5 2.4 3.2 0 4.8-1.2 4.8-3.5 0-1-.3-1.8-1.1-2.4-.7-.6-2.1-1.4-4.1-2.3-2.1-.9-3.6-1.9-4.5-2.8-1.1-1.2-1.6-2.7-1.6-4.5 0-2.1.8-3.8 2.5-5.2 1.6-1.4 3.8-2.1 6.4-2.1 2 0 3.8.4 5.3 1.2v4c-1.6-1.2-3.5-1.8-5.7-1.8-1.3 0-2.4.3-3.2 1-.8.7-1.2 1.5-1.2 2.5 0 1.1.3 2 1 2.6.6.6 1.9 1.3 3.8 2.1 2.1.9 3.7 1.8 4.6 2.8 1.3 1.2 1.9 2.7 1.9 4.5M179.5 41.4c0-3.2-.7-5.6-2.2-7.3-1.4-1.6-3.4-2.4-5.9-2.4-2.5 0-4.5.8-6 2.4-1.6 1.7-2.4 4.2-2.4 7.4 0 3 .8 5.3 2.3 7 1.5 1.7 3.6 2.5 6.1 2.5 2.6 0 4.6-.9 6-2.6 1.5-1.6 2.1-4 2.1-7m4.2-.2c0 4-1.1 7.2-3.4 9.6-2.2 2.4-5.3 3.6-9.1 3.6s-6.7-1.2-8.9-3.6c-2.1-2.3-3.2-5.4-3.2-9.2 0-4.4 1.2-7.7 3.7-10.1 2.3-2.2 5.3-3.3 9.1-3.3 3.7 0 6.6 1.2 8.7 3.5 2 2.3 3.1 5.5 3.1 9.5M201.3 20.3c-.8-.4-1.7-.7-2.7-.7-2.8 0-4.2 1.8-4.2 5.3v3.9h5.9v3.4h-5.9v21.6h-4V32.2h-4.3v-3.4h4.3v-4.1c0-2.8.8-4.9 2.6-6.5 1.5-1.4 3.3-2 5.4-2 1.2 0 2.2.1 2.9.4v3.7zM217.1 53.6c-.9.5-2.2.8-3.8.8-4.4 0-6.5-2.5-6.5-7.4V32.2h-4.3v-3.4h4.3v-6.1c1.3-.4 2.6-.8 4-1.3v7.4h6.3v3.4h-6.3v14.1c0 1.7.3 2.9.8 3.6.6.7 1.5 1.1 2.9 1.1 1 0 1.9-.3 2.6-.8v3.4z",
    transform: "translate(26.734177 116.658228)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.810127)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -102.6587,
    y1: 251.205,
    x2: -102.6587,
    y2: 249.5154,
    gradientTransform: "matrix(45.6076 0 0 -81.335 4807.2393 20433.4629)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0994dc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#66cef5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#66cef5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8462,
    style: {
      stopColor: "#127bca"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8462,
    style: {
      stopColor: "#127bca"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#127bca"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M99.4 23.4c10.4 31.8 14.3 88.4 44.7 88.4 2.3 0 4.6-.2 7-.7-27.6-6.4-30.9-62.5-47.7-91.5-1.4 1.3-2.7 2.5-4 3.8",
    style: {
      fill: "url(#SVGID_1_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -102.769,
    y1: 251.2097,
    x2: -102.769,
    y2: 249.5201,
    gradientTransform: "matrix(47.8692 0 0 -83.4083 5049.9253 20951.1875)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0e76bc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#36aee8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#36aee8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8462,
    style: {
      stopColor: "#00adef"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8462,
    style: {
      stopColor: "#00adef"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00adef"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103.3 19.7c16.8 29 20.1 85 47.7 91.5 2.2-.4 4.3-1 6.5-1.8-24.8-12.1-31.6-66.5-50.7-92.7-1.1.9-2.3 1.9-3.5 3",
    style: {
      fill: "url(#SVGID_2_)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.6 2.4c-2.3 0-4.6.2-7 .7-6.1 1.2-12.4 3.8-18.7 7.8 1.7 1.7 3.4 3.6 4.9 5.8 6.4-5.3 12.8-9.2 19.1-11.6 2.4-.9 4.7-1.5 7.1-2-1.7-.4-3.5-.7-5.4-.7",
    style: {
      fill: "#14559a"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -102.5632,
    y1: 249.7518,
    x2: -102.5632,
    y2: 251.0788,
    gradientTransform: "matrix(45.4522 0 0 -84.5 4820.5088 21212.6914)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1c63b7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#33bdf2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#33bdf2",
      stopOpacity: 0.4196
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M176.9 98.2c2.5-2 5.1-4.2 7.6-6.7-10.5-31.6-14.3-89-44.9-89-2.2 0-4.4.2-6.6.6 27.9 6.9 31.5 67.5 43.9 95.1",
    style: {
      fill: "url(#SVGID_3_)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133 3.1c-1.7-.4-3.5-.7-5.4-.7h12c-2.2.1-4.4.3-6.6.7",
    style: {
      fill: "#3092c4"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M176.4 104.9c-1.2-1.1-2.3-2.4-3.4-3.7-5.1 3.6-10.3 6.4-15.4 8.2 1.8.9 3.7 1.5 5.7 2 1.6.3 3.2.5 4.9.5 5.7 0 10.2-.7 14.1-2.5-2.2-1.2-4.1-2.7-5.9-4.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -102.5559,
    y1: 251.2284,
    x2: -102.5559,
    y2: 249.5388,
    gradientTransform: "matrix(45.0105 0 0 -86.5982 4767.5078 21739.8848)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#166ab8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#36aee8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#36aee8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8462,
    style: {
      stopColor: "#0798dd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8462,
    style: {
      stopColor: "#0798dd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0798dd"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M125.9 5.1c24.9 13 27.1 72.1 47 96.1 1.3-.9 2.7-1.9 4-3-12.5-27.6-16-88.2-43.9-95.1-2.3.4-4.7 1.1-7.1 2",
    style: {
      fill: "url(#SVGID_4_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: -103.1984,
    y1: 251.2255,
    x2: -103.1984,
    y2: 249.5359,
    gradientTransform: "matrix(58.3509 0 0 -92.0822 6161.6035 23118.1211)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#124379"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#1487cb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#1487cb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7802,
    style: {
      stopColor: "#165197"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7802,
    style: {
      stopColor: "#165197"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#165197"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M106.8 16.7c19.1 26.2 26 80.6 50.7 92.7 5.1-1.8 10.2-4.6 15.4-8.2-19.9-24-22.1-83.1-47-96.1-6.3 2.3-12.7 6.3-19.1 11.6",
    style: {
      fill: "url(#SVGID_5_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: -99.9321,
    y1: 250.4092,
    x2: -98.7992,
    y2: 250.4092,
    gradientTransform: "matrix(19.4176 0 0 -30.9219 2017.8317 7775.5972)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#33bdf2",
      stopOpacity: 0.698
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1dacd8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.2 22.7c-3 6.8-6.1 15.7-9.8 27.3 7.4-10.4 14.7-19.3 22-26.6-1-3.1-2.1-5.9-3.2-8.5-3 2.3-6.1 4.9-9 7.8",
    style: {
      fill: "url(#SVGID_6_)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8 13c-.9.6-1.8 1.3-2.7 2 1.2 2.5 2.2 5.4 3.2 8.5 1.3-1.3 2.6-2.6 4-3.8-1.4-2.4-2.9-4.7-4.5-6.7",
    style: {
      fill: "#2b74b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.9 10.9c-1 .7-2.1 1.4-3.1 2.1 1.6 2 3.1 4.3 4.5 6.7 1.2-1.1 2.3-2.1 3.5-3-1.5-2.2-3.1-4.1-4.9-5.8",
    style: {
      fill: "#125a9e"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: -103.5892,
    y1: 249.9375,
    x2: -103.5892,
    y2: 251.0444,
    gradientTransform: "matrix(79.1425 0 0 -98.6787 8440.8945 24769.3496)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#136ab4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#59caf5",
      stopOpacity: 0.549
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#59caf5",
      stopOpacity: 0.2353
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M272.1 0c-14.1 54.4-43.6 98.1-68.3 109.1-.4.2-.9.4-1.3.6-.1 0-.1 0-.2.1s-.3.1-.4.1c-.1 0-.1 0-.2.1-.2.1-.4.1-.6.2-.1 0-.2.1-.3.1-.1 0-.2.1-.3.1-.1 0-.2.1-.3.1-.1 0-.2.1-.3.1-.2.1-.3.1-.5.2-.1 0-.1 0-.2.1-.1 0-.2.1-.4.1-.1 0-.2 0-.2.1-.1 0-.3.1-.4.1-.2 0-.3.1-.5.1 1.1.4 2.3.6 3.5.6 23.4 0 47-42 86.1-111.8L272.1 0z",
    style: {
      fill: "url(#SVGID_7_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: -104.3196,
    y1: 250.4408,
    x2: -103.1868,
    y2: 250.4408,
    gradientTransform: "matrix(72.0226 0 0 -99.1613 7512.6992 24892.6055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#05a1e6",
      stopOpacity: 0.2471
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#05a1e6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.3 4.6c.1 0 .1 0 0 0l.1-.1c.1 0 .3-.1.4-.1h.2c.1 0 .3-.1.4-.1.3-.2.6-.3.9-.4h.1c.1 0 .3-.1.4-.1.1 0 .1 0 .2-.1.1 0 .3-.1.4-.1h.1c.4-.1.9-.2 1.3-.3h.2c.1 0 .2-.1.4-.1.1 0 .1 0 .2-.1.1 0 .2 0 .4-.1.3-.1.5-.1.8-.1h.2c.1 0 .2 0 .4-.1h.2c.1 0 .2 0 .3-.1h.2c.3 0 .6-.1.8-.1-.8-.1-1.6-.1-2.5-.1C52 2.4 15.7 51.4-.7 114.7h3.2c5.2-9.3 9.9-18.2 14.3-26.5C28.2 43.4 51.6 12.7 72.3 4.6",
    style: {
      fill: "url(#SVGID_8_)"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M87.2 22.7c3-2.9 6-5.4 9-7.7-.7-1.5-1.4-2.9-2.1-4.1-2.5 2.8-4.7 6.7-6.9 11.8M89.3 5c1.7 1.4 3.3 3.4 4.7 5.8.4-.5.9-1.1 1.4-1.5-2-1.8-4.1-3.3-6.4-4.5.1.1.2.1.3.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: -103.0346,
    y1: 249.5979,
    x2: -103.0346,
    y2: 251.1129,
    gradientTransform: "matrix(49.0511 0 0 -73.8222 5098.4824 18534.4668)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#318ed5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#38a7e4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.7 88.3C40.8 41.9 52.2 12.6 72.3 4.6c-20.7 8.2-44.1 38.8-55.6 83.7",
    style: {
      fill: "url(#SVGID_9_)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4 9.3c-.5.5-.9 1-1.4 1.5.8 1.3 1.5 2.6 2.1 4.1.9-.7 1.8-1.3 2.7-2-1.1-1.2-2.2-2.5-3.4-3.6",
    style: {
      fill: "#127bca"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: -102.8479,
    y1: 249.8817,
    x2: -102.8479,
    y2: 251.7848,
    gradientTransform: "matrix(45.6036 0 0 -57.1283 4741.792 14384.3242)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#05a1e6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#05a1e6",
      stopOpacity: 0.549
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.7 114.5c-.1 0-.3 0-.4.1h-.6c-.3 0-.6 0-.9.1h-.1c24.3-.7 35.5-12.9 41-30.6 4.2-13.4 7.6-24.7 10.7-34.2C67.2 64.3 57 81.4 46.7 100.5c-5 9.3-12.6 13.2-19 14",
    style: {
      fill: "url(#SVGID_10_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: -103.1532,
    y1: 249.8467,
    x2: -103.1532,
    y2: 250.9796,
    gradientTransform: "matrix(52.5191 0 0 -81.0936 5474.916 20375.4961)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1959a6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#05a1e6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#05a1e6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9176,
    style: {
      stopColor: "#7ec5ea"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7ec5ea"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.7 114.5c6.5-.8 14-4.7 19-13.9C56.9 81.4 67.2 64.3 77.4 50c3.7-11.6 6.8-20.5 9.8-27.3C66.8 42 46.5 74.1 27.7 114.5",
    style: {
      fill: "url(#SVGID_11_)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7 88.3c-4.3 8.3-9 17.1-14.3 26.5h9.2c1.3-9.3 3-18.2 5.1-26.5",
    style: {
      fill: "#05a1e6"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: -103.635,
    y1: 249.9357,
    x2: -103.8767,
    y2: 250.9418,
    gradientTransform: "matrix(72.6768 0 0 -99.0047 7592.7998 24853.4746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#165096"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0d82ca"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80.1 2.6h-.7c-.1 0-.2 0-.4.1h-.2c-.3 0-.5.1-.8.1h-.1c-.1 0-.3.1-.4.1-.1 0-.1 0-.2.1-.1 0-.3.1-.4.1h-.2c-.4.1-.9.2-1.3.3h-.1c-.1 0-.3.1-.4.1-.1 0-.1 0-.2.1-.1 0-.3.1-.4.1h-.1c-.2.3-.5.5-.8.5-.1 0-.3.1-.4.1-.1 0-.1 0-.2.1-.1 0-.3.1-.4.1 0 0-.1 0-.1.1-20.1 7.9-31.5 37.3-55.6 83.6-2.1 8.3-3.9 17.2-5.1 26.5H25.9c.3 0 .6 0 .9-.1h.6c.1 0 .3 0 .4-.1C46.6 74.1 67 42 87.3 22.6c2.2-5.1 4.4-8.9 6.8-11.8-1.4-2.4-3-4.4-4.7-5.8h-.1c-.1 0-.2-.1-.3-.1-.1-.1-.2-.1-.3-.1-.1 0-.2-.1-.3-.1-.1 0-.2-.1-.3-.1-.1 0-.2-.1-.3-.1-.2-.1-.4-.1-.5-.2-.1 0-.2-.1-.2-.1-.1 0-.3-.1-.4-.2-.1 0-.1 0-.2-.1-.2-.1-.4-.1-.6-.2-.2-.1-.4-.1-.6-.2h-.1c-.2-.1-.4-.1-.5-.2h-.1c-.6-.2-1-.3-1.5-.4H83c-.2 0-.4-.1-.6-.1h-.1c-.2 0-.5-.1-.7-.1h-.1c-.2 0-.4 0-.5-.1-.3 0-.6.1-.9 0",
    style: {
      fill: "url(#SVGID_12_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: -101.284,
    y1: 250.1402,
    x2: -101.284,
    y2: 251.0499,
    gradientTransform: "matrix(32.7663 0 0 -57.2261 3542.5979 14366.8955)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#05a1e6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8736,
    style: {
      stopColor: "#0495d6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0495d6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M217 30.1c-4.6 14.8-8.4 27.1-11.6 37.1 12.7-17.5 25.2-39.5 37.1-64.8-13.9 4.4-21.4 14.4-25.5 27.7",
    style: {
      fill: "url(#SVGID_13_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: -102.9005,
    y1: 251.0575,
    x2: -103.2517,
    y2: 249.8113,
    gradientTransform: "matrix(60.2691 0 0 -96.3231 6450.0854 24178.1055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#38a7e4",
      stopOpacity: 0.3294
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9615,
    style: {
      stopColor: "#0e88d3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9615,
    style: {
      stopColor: "#0e88d3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0e88d3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M205.7 108.2c-.6.3-1.3.6-1.9.9C228.5 98.1 258 54.4 272.1 0h-2.9c-32.4 57.9-42.8 96.7-63.5 108.2",
    style: {
      fill: "url(#SVGID_14_)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.6 103.3c5.4-6.6 9.8-17.7 15.7-36.1-6.9 9.5-13.8 17.6-20.8 24.2v.1c1.5 4.6 3.2 8.6 5.1 11.8",
    style: {
      fill: "#079ae1"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M189.6 103.3c-1.8 2.2-3.8 3.9-5.9 5.2-.5.3-.9.5-1.4.8 2.3 1.2 4.8 2 7.5 2.4.4 0 .8.1 1.2.1h3.7c.2 0 .3 0 .5-.1h.1c.2 0 .3-.1.5-.1h.2c.2 0 .4-.1.6-.1h.1c.4-.1.8-.1 1.2-.2-3.3-1.2-6-4-8.3-8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M144.1 111.8c2.3 0 4.6-.2 7-.7 2.2-.4 4.3-1 6.5-1.8 1.8.9 3.7 1.5 5.7 2 1.6.3 3.2.5 4.9.5h-24.1zM168.2 111.8c5.7 0 10.2-.7 14.1-2.5 2.3 1.2 4.8 2 7.5 2.4.4 0 .8.1 1.2.1h1.4-24.2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M192.4 111.8h2.2c.2 0 .3 0 .5-.1h.1c.2 0 .3-.1.5-.1h.2c.2 0 .4-.1.6-.1h.1c.4-.1.8-.1 1.2-.2 1.1.4 2.3.6 3.5.6l-8.9-.1z",
    style: {
      fill: "#1d60b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.5 91.6c-2.5 2.4-5.1 4.6-7.6 6.6-1.3 1.1-2.6 2-4 3 1.1 1.3 2.3 2.6 3.4 3.7 1.8 1.8 3.8 3.2 5.9 4.4.5-.2 1-.5 1.4-.8 2.2-1.3 4.1-3 5.9-5.2-1.8-3.2-3.4-7.2-5-11.7",
    style: {
      fill: "#175fab"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: -103.3999,
    y1: 251.0135,
    x2: -103.3999,
    y2: 249.856,
    gradientTransform: "matrix(70.2816 0 0 -98.1105 7496.5054 24626.7363)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#168cd4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#1c87cc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#154b8d"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M260.2 0H245.9c-.8 0-1.5.1-2.3.1-.4.8-.7 1.5-1.1 2.3-11.9 25.4-24.4 47.4-37.1 64.8-6 18.4-10.4 29.5-15.7 36.1 2.3 3.9 5 6.7 8.1 7.8.1 0 .2 0 .3-.1H198.4c.1 0 .3-.1.4-.1.1 0 .2 0 .2-.1.1 0 .2-.1.4-.1.1 0 .1 0 .2-.1.2-.1.4-.1.5-.2.1 0 .2-.1.3-.1.1 0 .2-.1.3-.1.1 0 .2-.1.3-.1.1 0 .2-.1.3-.1.2-.1.4-.1.6-.2.1 0 .1-.1.2-.1.1-.1.3-.1.4-.1 0 0 .1 0 .2-.1.4-.2.9-.4 1.3-.6.6-.3 1.3-.6 1.9-.9 20.5-11.3 30.9-50.1 63.3-108h-9z",
    style: {
      fill: "url(#SVGID_15_)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9 2.6h.6c.2 0 .5.1.7.1h.1c.2 0 .4.1.6.1h.1c.5.2 1 .3 1.4.4h.1c.2 0 .4.1.5.2h.1c.2.1.4.1.6.2.2.1.4.1.6.2.1 0 .1.1.2.1.3.1.5.1.6.2.1 0 .1.1.2.1.2.1.4.1.5.2.1 0 .2.1.3.1.1.1.2.1.3.1.1 0 .2.1.3.1.1.1.2.1.3.1 2.3 1.1 4.4 2.6 6.4 4.5.7-.8 1.5-1.4 2.3-2.1-4.3-3-9.1-4.8-14.7-4.8-.8.1-1.4.2-2.1.2",
    style: {
      fill: "#7dcbec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4 9.3c1.2 1.1 2.3 2.4 3.4 3.7 1.1-.7 2.1-1.4 3.1-2.1-1.4-1.4-2.8-2.6-4.3-3.7-.8.7-1.5 1.3-2.2 2.1",
    style: {
      fill: "#5ec5ed"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: -102.083,
    y1: 248.6358,
    x2: -101.2771,
    y2: 251.1893,
    gradientTransform: "matrix(32.4594 0 0 4.2491 3398.1206 -1059.1373)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#97d6ee"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7033,
    style: {
      stopColor: "#55c1ea"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#55c1ea"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80.9 2.6c.7-.1 1.3-.1 2-.1 5.6 0 10.5 1.7 14.7 4.8 4.5-3.6 10-4.8 17.6-4.8H78.4c.9-.1 1.7 0 2.5.1",
    style: {
      fill: "url(#SVGID_16_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: -101.3187,
    y1: 250.9661,
    x2: -100.5385,
    y2: 249.715,
    gradientTransform: "matrix(26.4722 0 0 7.484 2781.8201 -1867.8629)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7accec"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3fb7ed"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.2 2.4c-7.6 0-13.1 1.2-17.6 4.8 1.5 1.1 2.9 2.3 4.3 3.7 6.3-4 12.5-6.7 18.7-7.8 2.3-.4 4.7-.7 7-.7h-12.4z",
    style: {
      fill: "url(#SVGID_17_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: -102.7809,
    y1: 250.9401,
    x2: -102.7809,
    y2: 249.5625,
    gradientTransform: "matrix(52.0449 0 0 -80.6355 5563.2627 20240.6543)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1da7e7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#37abe7",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M205.3 67.3c3.3-10.1 7-22.3 11.6-37.1 4.2-13.4 11.6-23.4 25.5-27.7.4-.7.7-1.5 1.1-2.3C220.9 1.5 210.3 13 205 30.1c-9.3 29.8-15 49.1-20.4 61.4 6.9-6.6 13.8-14.8 20.7-24.2",
    style: {
      fill: "url(#SVGID_18_)"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M238.6 103.9H236v8h-1v-8h-2.6v-.9h6.2v.9zM249.1 111.9h-1v-6c0-.5 0-1.1.1-1.7-.1.4-.2.7-.3.9l-3 6.9h-.5l-3-6.8c-.1-.2-.2-.5-.3-.9v7.7h-1v-8.9h1.4l2.7 6.2c.2.5.3.8.4 1.1.2-.5.3-.9.4-1.1l2.8-6.2h1.3v8.8z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M101.4 217s-.4 1-.5 1.5v-.5l.2-26.3H84.2L74 217.2c-.4 1-.8 2-1.1 2.9v-2.2l-.1-26.2H56.2l2.2 58.3h16.8l9.7-23.1 1.2-3v1.8l.4 24.4h16.6l25.7-58.3h-17.6l-9.8 25.2zM171.6 195.4c-4.7-3.3-11.1-4-15.6-4-5.3 0-10.9.6-14.5 1.5l-1.6.4-10.8 56.7h16.4l3.6-18.9c.9.1 1.7.1 2.6.1 7.6 0 14-1.9 18.5-5.4 5.3-4.1 8.2-10.2 8.2-17 0-5.7-2.4-10.4-6.8-13.4zM153 216.9h-1.3l2.1-11.2c.6-.1 1.4-.1 2.4-.1 5.5 0 5.5 2.8 5.5 4.2.1 4.1-3.6 7.1-8.7 7.1zM229.1 206.6l2.9-14.9h-36.3L184.6 250h16.6l4-21.4h18.4l2.9-14.7H208l1.4-7.3z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWpf);
export default __webpack_public_path__ + "static/media/wpf.0fd8d260f949a8f2c9fd5fc9f195f3bc.svg";
export { ForwardRef as ReactComponent };